var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"ma-0 pa-0",attrs:{"fluid":"","grid-list-xs":""}},[_c('Hero'),_c('Values'),_c('Entries'),_c('Investments'),_c('Gallery'),_c('Location'),_c('Contact')],1)}
var staticRenderFns = []

export { render, staticRenderFns }